import React from "react";
import { Link } from "react-router-dom";
import "./../styles/OnlineServices.scss";

const OnlineServices = () => {
  return (
    <>
      <header className="online-services-header"></header>
      <div className="breadcrumbz container-sm ">
        <ol>
        <li>
            <Link to="/">
            Anasayfa <span>&gt;</span>
            </Link>
        </li>
        <li>
            <Link to="/online-islemler">
                Online İşlemler
            </Link>
        </li>
        </ol>
      </div>
      <div className="online-services-content-container container-sm">
        <div className="online-services-container">
          <div className="left-box">
              <a href="https://musteriportal.sankoenerji.com.tr/Login/IndexDefault" target="_blank">
                <img className="left-box-image"></img>
              </a>              
          </div>
          <div className="right-row">
            <div className="right-box-1">
                <a href="/faaliyet-alanlari/yesil-enerji?q=1032">
                    <img className="right-box-1-image"></img>
                </a>
            </div>
            <div className="right-box-2">
                <a href="/faaliyet-alanlari/elektrik-satisi?q=1026">
                    <img className="right-box-2-image"></img>
                </a>                
            </div>
          </div>          
        </div>
      </div>
    </>
  );
};

export default OnlineServices;
